import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSignOut, useSignIn } from "react-auth-kit";
import {
  downloadFile,
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";
import { filterHandler, showFlowType } from "../../services/helpers";

import FlowHistoryModal from "../Modals/FlowHistoryModal";
import UserContext from "../../store/user-context";
import { Table, Icon, Alert, Chip, ChipLabel } from "design-react-kit";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import DownloadTypeEnum from "../../helpers/Enums/DownloadTypeEnum";

const FlowsTable = ({ items, columns, filters, getFlows }) => {
  const [results, setResults] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState(null);
  const [error, setError] = useState(null);
  const [modalError, setModalError] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
  }, [items]);

  const showStatus = (status, statusLong) => {
    if (status !== undefined) {
      if (
        status === "Cartella dei documenti mancante" ||
        status === "File scartato" ||
        status === "Problemi nell’upload report avanzamento	"
      ) {
        return (
          <span title={statusLong} className="text-nowrap">
            <Chip simple color="danger" className="text-nowrap">
              <ChipLabel>{status}</ChipLabel>
            </Chip>
          </span>
        );
      } else if (status === "Processo notifiche completato") {
        return (
          <span title={statusLong} className="text-nowrap">
            <Chip simple color="success" className="text-nowrap">
              <ChipLabel>{status}</ChipLabel>
            </Chip>
          </span>
        );
      } else {
        return (
          <span title={statusLong} className="text-nowrap">
            <Chip simple color="info" className="text-nowrap">
              <ChipLabel>{status}</ChipLabel>
            </Chip>
          </span>
        );
      }
    }
  };

  const modalOpenHandler = (flow) => {
    setModalOpen(true);
    setModalError(null);
    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      const data = {
        fiscalCode: userContext.selectedClientFiscalCode,
        flowId: flow.id,
      };
      sendApiRequest(
        "FLow/GetFlowHistory",
        "GET",
        true,
        data,
        signIn,
        signOut,
        navigate,
        createQueryString,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setModalError(response.errors);
            document
              .querySelector("#table-modal .modal-content")
              .classList.add("scale");
          } else {
            setHistoryData({
              ...response.data,
              flowName: flow.name,
              flowType: flow.flowType,
              clientServiceDescription: flow.clientServiceDescription,
            });
            document
              .querySelector("#table-modal .modal-content")
              .classList.add("scale");
          }
        }
      });
    }
  };

  const modalCloseHandler = () => {
    document
      .querySelector("#table-modal .modal-content")
      .classList.remove("scale");
    setTimeout(() => {
      setModalOpen(false);
    }, 600);
  };

  const downloadFileHandler = (fileName, clientCode) => {
    setError(null);
    if (
      userContext.selectedClientFiscalCode !== null &&
      userContext.selectedClientName !== null
    ) {
      const data = {
        downloadType: DownloadTypeEnum.FlowResult,
        fileName,
        fiscalCode: userContext.selectedClientFiscalCode,
        clientCode,
      };
      downloadFile(data, signIn, signOut, navigate, userContext).then(
        (response) => {
          if (response.errors === undefined) {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = `${fileName}`;
              a.click();
            });
          } else {
            setError([response.errors.message]);
            modalCloseHandler();
          }
        }
      );
    }
  };

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Ricerca per nome"}
            column={"name"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getFlows(filters)}
            />
          </span>
        </div>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="predispositionDate text-center">
                      {result.importDate}
                    </td>
                    <td className="name">{result.name}</td>
                    <td className="client text-nowrap">
                      {result.clientServiceDescription}
                    </td>
                    <td className="froamt text-nowrap">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="lastElaborationDate text-center">
                      {result.lastProcessDate}
                    </td>
                    <td className="status text-center">
                      {showStatus(result.status, result.statusLong)}
                    </td>
                    <td className="actions text-center">
                      {result.lastResultFile !== "" && (
                        <span
                          title="Scarico esito lavorazione"
                          className="mr-2"
                        >
                          <Icon
                            id="download-file"
                            icon="it-download"
                            fill="#06c"
                            role="button"
                            onClick={(e) =>
                              downloadFileHandler(
                                encodeURIComponent(result.lastResultFile),
                                result.code
                              )
                            }
                          />
                        </span>
                      )}
                      <span title="Cronologia lavorazioni">
                        <Icon
                          id="view-history"
                          icon="it-password-visible"
                          fill="#005A9A"
                          role="button"
                          onClick={(e) => modalOpenHandler(result)}
                        />
                      </span>
                    </td>
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <FlowHistoryModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
        historyData={historyData}
        downloadFileHandler={downloadFileHandler}
        showStatus={showStatus}
        error={modalError}
        page="flowsHistory"
      />
    </Fragment>
  );
};

export default FlowsTable;
